module.exports = __webpack_public_path__ + "img/audioicon.2f7fd945.png";